import { fetcher } from './fetcher';
import TAnimation from './tquery.js';

export const INTERVAL_PAYMENT_STATUS = 5000;
export const MAX_RETRIES = 60;

export const paymentFormCloseButton = {
  hide() {
    const btn = document.getElementById('payment-form-close-button');
    if (btn) {
      btn.style.display = 'none';
    }
  },
  show() {
    const btn = document.getElementById('payment-form-close-button');
    if (btn) {
      btn.style.display = 'block';
    }
  },
};

export const payButton = {
  getBtn() {
    return document.querySelector('.js-pay-button');
  },

  enable() {
    if (this.getBtn()) {
      this.getBtn().disabled = false;
      this.getBtn().classList.remove('disabled');
      this.getBtn().style.pointerEvents = 'auto';
    }
  },

  disable() {
    if (this.getBtn()) {
      this.getBtn().disabled = true;
      this.getBtn().classList.add('disabled');
      this.getBtn().style.pointerEvents = 'none';
    }
  },
};

export const applePayButtons = {
  getBtns() {
    return document.querySelectorAll('.js-apple-pay-btn');
  },

  enable() {
    const btns = this.getBtns();
    btns.forEach(btn => (btn.disabled = false));
    btns.forEach(btn => btn.classList.remove('disabled'));
    btns.forEach(btn => (btn.style.pointerEvents = 'auto'));
  },

  disable() {
    const btns = this.getBtns();
    btns.forEach(btn => (btn.disabled = true));
    btns.forEach(btn => btn.classList.add('disabled'));
    btns.forEach(btn => (btn.style.pointerEvents = 'none'));
  },

  hide() {
    this.getBtns().forEach(btn => (btn.style.display = 'none'));
  },
};

export const formError = {
  clear(selector) {
    let errorNode = document.querySelector(`[data-error-field="${selector}"]`);
    errorNode.classList.add('hidden');
  },
  display(selector, message) {
    let errorNode = document.querySelector(`[data-error-field="${selector}"]`);
    errorNode.classList.remove('hidden', 'none');
    message && (errorNode.textContent = message);
  },
};

export const attachAnimationMethods = (element, method) => {
  if (typeof element[method] === 'function') {
    return element;
  }
  return new TAnimation(element);
};

export const formLoader = {
  hide() {
    let element = document.querySelector('.js-payment-loader');
    document.body.classList.remove('overflow-hidden');
    if (!element) return;
    element = attachAnimationMethods(element, 'fadeOut');
    element.fadeOut();
  },
  show() {
    let element = document.querySelector('.js-payment-loader');
    document.body.classList.add('overflow-hidden');
    if (!element) return;
    element = attachAnimationMethods(element, 'fadeIn');
    element.fadeIn('flex');
  },
  changeMessage() {
    const paymentMessage = document.querySelector('.js-payment-message');
    let element = document.querySelector('.js-msg-spin');
    if (!paymentMessage) return;
    paymentMessage.innerText = backEndVars.paymentDone;
    element = attachAnimationMethods(element, 'fadeOut');
    element.fadeOut();
  },
};

export const btnLoader = {
  hide(selector) {
    let loader = document.querySelector(`[data-btn-loader="${selector}"]`);
    loader && loader.classList.add('hidden');
  },
  show(selector) {
    let loader = document.querySelector(`[data-btn-loader="${selector}"]`);
    loader && loader.classList.remove('hidden');
  },
};

let retries = 0;

const buildUrlWithQueryParams = (checkUrl, data) => {
  return `${checkUrl}?${new URLSearchParams(data).toString()}`;
};

export const checkPaymentStatusSuccessCb = (
  route,
  gtmData,
  purchased_category,
  purchased_type,
  intervalId,
  options,
) => {
  store.appendDiffTypes('nextUrl', route);

  if (route) {
    const { redirectToURL, selector, onSuccess } = options;

    setProductsPaid(purchased_category, purchased_type);

    formLoader.changeMessage();
    pushGTMDataLayer(gtmData);
    redirectToURL && selector && redirectToURL(route, selector);
    clearInterval(intervalId);
    onSuccess && onSuccess();

    return true;
  }
};

export const checkPaymentStatusAndRedirect = (selector, checkUrl, data, retryOnFail = false, retryCount = 5) => {
  const urlWithQueryParams = buildUrlWithQueryParams(checkUrl, data);
  btnLoader.show(selector);
  paymentFormCloseButton.hide();
  formLoader.show();
  let intervalId = setInterval(() => {
    fetcher
      .get(urlWithQueryParams)
      .then(({ route, gtmData, purchased_category, purchased_type }) => {
        checkPaymentStatusSuccessCb(route, gtmData, purchased_category, purchased_type, intervalId, {
          redirectToURL,
          selector,
        });
      })
      .catch(response => {
        if (retryOnFail && retryCount > 0) {
          return checkPaymentStatusAndRedirect(selector, checkUrl, data, retryOnFail, retryCount--);
        }

        onChecksError(response, selector, intervalId);
      })
      .finally(onChecksFinally(intervalId, selector));
  }, INTERVAL_PAYMENT_STATUS);
};

const checkPaymentStatus = (selector, checkUrl, data, onSuccess) => {
  const urlWithQueryParams = buildUrlWithQueryParams(checkUrl, data);
  btnLoader.show(selector);
  paymentFormCloseButton.hide();
  formLoader.show();
  let intervalId = setInterval(() => {
    fetcher
      .get(urlWithQueryParams)
      .then(({ route, gtmData, purchased_category, purchased_type }) => {
        checkPaymentStatusSuccessCb(route, gtmData, purchased_category, purchased_type, intervalId, { onSuccess });
      })
      .catch(response => onChecksError(response, selector, intervalId))
      .finally(onChecksFinally(intervalId, selector));
  }, INTERVAL_PAYMENT_STATUS);
};

export function onChecksFinally(intervalId, selector) {
  if (++retries >= MAX_RETRIES) {
    formError.display(selector, 'Timeout.');
    formLoader.hide();
    btnLoader.hide(selector);
    paymentFormCloseButton.show();
    payButton.enable();
    applePayButtons.enable();
    clearInterval(intervalId);
    return false;
  }
}

export function onChecksError(response, selector, intervalId) {
  const { error } = response;
  intervalId && clearInterval(intervalId);
  formError.display(selector, error);
  formLoader.hide();
  btnLoader.hide(selector);
  paymentFormCloseButton.show();
  payButton.enable();
  applePayButtons.enable();
  return false;
}

export const flows = {
  web: function () {
    checkPaymentStatusAndRedirect(...arguments);
  },
};

document.addEventListener('DOMContentLoaded', () => {
  if (currentProductAlreadyPurchased()) {
    moveToNextUrl();
  }

  window.payments = {
    formError,
    formLoader,
    btnLoader,
    paymentFormCloseButton,
    payButton,
    applePayButtons,
    checkPaymentStatusAndRedirect,
    flows,
  };
});
